export default __webpack_public_path__ + "static/media/client3.68f0071b.jpg";